module.exports = __webpack_public_path__ + "img/clear.c4899824.svg";